import styled from 'styled-components';

export const Wrapper = styled.div`

    form ._2lUSM {
      margin-bottom:15px;
      
    } 
    .mensaje {
      margin-bottom: 20px;
  }
    .horario {
      margin-bottom: 24px;
  } 
    .horario b {
    font-size: 1.5rem;
    line-height: 1.5;
  }
    .horario p {
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 400;
  }
    .sello {
      display: grid;
      grid-template-columns: 0.5fr 1fr;
  }
    .sello p {
    margin-top: 28px;
    margin-left: 24px;
    color: #A5A5A5;
  }
    .mensajeInfo {
    margin-bottom: 20px;
    margin-top: 20px;
  }
    .contenedor {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
    gap: 32px;
  } 
  .info .p-mensaje {
    font-weight: bold;
    line-height: 19px;
}
    .info .p-coment{
      margin-top: 4px;
      color: #333333;
    }
    
    @media (max-width: 425px){
      ._sqrUW {
          font-size: 1.1rem !important;
          line-height: 1.5;
      }
      .info .p-mensaje {
        font-size: 0.9rem;
    }
      .contenedor {
        grid-template-columns: 1fr ;
      } 
      .info .p-coment {
        
        font-size: 0.8rem;
      }

    }
    @media (max-width: 375px){
      ._sqrUW {
          font-size: 1.1rem !important;
          line-height: 1.5;
      }
      .info .p-mensaje {
        font-size: 0.9rem;
    }
    .contenedor {
      grid-template-columns: 1fr ;
    } 
    }
    @media (max-width: 320px){
        ._sqrUW {
            font-size: 1.1rem !important;
            line-height: 1.5;
        }
        .info .p-mensaje {
          font-size: 0.9rem;
      }
      .contenedor {
        grid-template-columns: 1fr ;
      } 
      .info .p-coment {
        margin-top: 4px;
        font-size: 0.8rem;
      }
      
      }


    
   
`;

export default Wrapper;